import React from 'react';
import TableFilterInput from '../../../../../components/table/TableFilterInput';

/**
 *  선택된 홈 아이템 리스트와 홈 리스트의 공통 컬럼
 */
export const columns = (data) => {
  const { filterOption, onFilter } = data;
  return [
    {
      accessor: 'title',
      Header: '제목',
      filterable: !!filterOption,
      fixed: 'left',
      width: 200,
      Filter: () => (
        <TableFilterInput option={filterOption.mainTitle} onFilter={(mainTitle) => onFilter({ mainTitle })} />
      ),
    },
    {
      accessor: 'memo',
      Header: '메모',
      width: 800,
    },
  ];
};
